// extracted by mini-css-extract-plugin
export default {"flexBetween":"AuctionSection_flexBetween__rxXpn"};